import getDifferenceBetweenNumbers from '../../../../../../../../../../tools/getDifferenceBetweenNumbers';
import { IExtendedTenant } from '../../../interfaces';
import { IDataForSort } from '../interfaces';
import { cloneDeep, isNull, isUndefined } from 'lodash';

interface IArgs {
    tenants: IExtendedTenant[];
    dataForSort: IDataForSort;
}

const sortHandler = (a: number | null, b: number | null, isReverse: boolean): number => {
    if (isNull(a)) return isReverse ? -1 : 1;
    if (isNull(b)) return isReverse ? 1 : -1;
    if (isReverse) return a < b ? -1 : 1;
    else return a > b ? -1 : 1;
};

/**
 * Функция для сортировки арендаторов
 * @param dataForSort данные для сортировки
 * @param tenants все арендаторы
 */
const sortTenants = (args: IArgs): IExtendedTenant[] => {
    const { tenants, dataForSort } = args;

    return cloneDeep(tenants).sort((a, b) => {
        if (a.metrics && b.metrics) {
            const aValue: number | null | undefined = a.metrics[dataForSort.metricId]?.mainPeriod?.items[0]?.value;
            const bValue: number | null | undefined = b.metrics[dataForSort.metricId]?.mainPeriod?.items[0]?.value;

            let aCompareValue = null;
            let bCompareValue = null;

            if (!isNull(aValue) && !isUndefined(aValue)) {
                const difference = getDifferenceBetweenNumbers(
                    aValue,
                    a.metrics[dataForSort.metricId].comparePeriod?.items[0].value,
                );
                aCompareValue = +difference.percentDifference;
            }

            if (!isNull(bValue) && !isUndefined(bValue)) {
                const difference = getDifferenceBetweenNumbers(
                    bValue,
                    b.metrics[dataForSort.metricId].comparePeriod?.items[0].value,
                );
                bCompareValue = +difference.percentDifference;
            }

            if (dataForSort.periodType === 'mainPeriod') {
                return sortHandler(aValue, bValue, dataForSort.ordering === 'up' ? false : true);
            }

            if (dataForSort.periodType === 'comaprePeriod') {
                return sortHandler(aCompareValue, bCompareValue, dataForSort.ordering === 'up' ? false : true);
            }
        }
        return 1;
    });
};

export default sortTenants;
